const React = require('react');
const { createElement: h } = React;

// Shared AlleFlow wordmark used across the auth surface (LoginPage,
// ResetPasswordPage) so every auth screen shows the same brand header.
// Kept in one place to avoid duplicating the SVG per page.
function AuthBrand() {
  return h('div', { className: 'lp-brand' },
    h('svg', {
      width: 140, height: 34, viewBox: '0 0 128 30',
      fill: 'none', xmlns: 'http://www.w3.org/2000/svg',
      'aria-label': 'AlleFlow'
    },
      h('rect', { x: 0, y: 3, width: 24, height: 24, rx: 6, fill: '#1a1f2e' }),
      h('circle', { cx: 8, cy: 15, r: 2.5, fill: 'white', fillOpacity: 0.9 }),
      h('line', { x1: 10.5, y1: 15, x2: 13.5, y2: 15, stroke: 'white', strokeWidth: 1.5, strokeOpacity: 0.65 }),
      h('path', { d: 'M13 12 L17 15 L13 18', stroke: 'white', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' }),
      h('text', {
        x: 31, y: 21,
        fontFamily: 'Manrope, Segoe UI, sans-serif',
        fontSize: 17, fontWeight: 800,
        letterSpacing: -0.4, fill: '#1a1f2e'
      }, 'AlleFlow')
    )
  );
}

module.exports = AuthBrand;
